module.exports = __webpack_public_path__ + "b2946bd89485be3b8b641a5385634bb3.svg";